<template>
  <!-- Banner -->
  <section class="banner-section banner-nine">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="banner-contents">
            <h1
              class="aos"
              data-aos="fade-up"
              data-aos-anchor-placement="top-bottom"
            >
              Find Your Dream Home
            </h1>
            <h6
              class="mb-0 aos"
              data-aos="fade-up"
              data-aos-anchor-placement="top-bottom"
            >
              Only real estate platform with 10,000+ highly rated sellers
            </h6>
            <p class="aos" data-aos="fade-up" data-aos-delay="200">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s,
            </p>
            <div class="banner-nine-btn-group">
              <router-link
                to="categories"
                class="aos"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <span>Add Listing</span>
              </router-link>
              <router-link
                to="categories"
                class="aos"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <span>Search Property</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Banner -->

  <!-- Search Filter Section -->
  <section
    class="car-search-filter realestate-search-filter aos"
    data-aos="fade-up"
    data-aos-delay="400"
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="car-filter-section">
            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                >
                  Buy Property
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="pills-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                >
                  Sell Property
                </button>
              </li>
            </ul>
            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
                tabindex="0"
              >
                <div class="search-tab-col">
                  <form action="listing-grid-sidebar">
                    <div class="row align-items-center search-form">
                      <div class="col-12 col-lg-10 datepicker-col search-group">
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="d-flex real-estate-search">
                              <div
                                class="flex-shrink-0 d-flex align-items-center"
                              >
                                <div class="icon-blk rounded-circle">
                                  <span><i class="feather-map-pin"></i></span>
                                </div>
                              </div>
                              <div class="flex-grow-1 estate-input">
                                <input
                                  type="text"
                                  name="name"
                                  class="border-0 text-truncate px-0 form-control"
                                  placeholder="Search location of Property"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-2">
                            <div class="d-flex real-estate-search">
                              <div
                                class="flex-shrink-0 d-flex align-items-center"
                              >
                                <div class="icon-blk rounded-circle">
                                  <span><i class="feather-calendar"></i></span>
                                </div>
                              </div>
                              <div class="flex-grow-1 estate-input">
                                <input
                                  type="text"
                                  name="checkin"
                                  class="border-0 text-truncate px-0 form-control datetimepicker"
                                  placeholder="Check-in"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-2">
                            <div class="d-flex real-estate-search">
                              <div
                                class="flex-shrink-0 d-flex align-items-center"
                              >
                                <div class="icon-blk rounded-circle">
                                  <span><i class="feather-calendar"></i></span>
                                </div>
                              </div>
                              <div class="flex-grow-1 estate-input">
                                <input
                                  type="text"
                                  name="checkout"
                                  class="border-0 text-truncate px-0 form-control datetimepicker"
                                  placeholder="Check- out"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-2">
                            <div class="d-flex real-estate-search real-select">
                              <div
                                class="flex-shrink-0 d-flex align-items-center"
                              >
                                <div class="icon-blk rounded-circle">
                                  <span><i class="feather-users"></i></span>
                                </div>
                              </div>
                              <div class="flex-grow-1 estate-input">
                                <vue-select
                                  class="form-control select category-select"
                                  :options="CategoryNine"
                                  placeholder="Guest"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-2 real-search-bar">
                        <button class="btn car-search-icon" type="submit">
                          Search Properties
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div
                class="tab-pane fade show"
                id="pills-profile"
                role="tabpanel"
                aria-labelledby="pills-profile-tab"
                tabindex="0"
              >
                <div class="search-tab-col">
                  <form action="listing-grid-sidebar">
                    <div class="row align-items-center search-form">
                      <div class="col-12 col-lg-10 datepicker-col search-group">
                        <div class="row">
                          <div class="col-xl-6 col-lg-3">
                            <div class="d-flex real-estate-search">
                              <div
                                class="flex-shrink-0 d-flex align-items-center"
                              >
                                <div class="icon-blk rounded-circle">
                                  <span><i class="feather-map-pin"></i></span>
                                </div>
                              </div>
                              <div class="flex-grow-1 estate-input">
                                <input
                                  type="text"
                                  name="name"
                                  class="border-0 text-truncate px-0 form-control"
                                  placeholder="Search location of Property"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-xl-2 col-lg-3">
                            <div class="d-flex real-estate-search">
                              <div
                                class="flex-shrink-0 d-flex align-items-center"
                              >
                                <div class="icon-blk rounded-circle">
                                  <span><i class="feather-calendar"></i></span>
                                </div>
                              </div>
                              <div class="flex-grow-1 estate-input">
                                <input
                                  type="text"
                                  name="checkin"
                                  class="border-0 text-truncate px-0 form-control datetimepicker"
                                  placeholder="Check-in"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-xl-2 col-lg-3">
                            <div class="d-flex real-estate-search">
                              <div
                                class="flex-shrink-0 d-flex align-items-center"
                              >
                                <div class="icon-blk rounded-circle">
                                  <span><i class="feather-calendar"></i></span>
                                </div>
                              </div>
                              <div class="flex-grow-1 estate-input">
                                <input
                                  type="text"
                                  name="checkout"
                                  class="border-0 text-truncate px-0 form-control datetimepicker"
                                  placeholder="Check- out"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-xl-2 col-lg-3">
                            <div class="d-flex real-estate-search real-select">
                              <div
                                class="flex-shrink-0 d-flex align-items-center"
                              >
                                <div class="icon-blk rounded-circle">
                                  <img
                                    src="@/assets/img/icons/users.svg"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div class="flex-grow-1 estate-input">
                                 <vue-select
                                  class="form-control select category-select"
                                  :options="CategoryNine"
                                  placeholder="Guest"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-2 real-search-bar">
                        <button class="btn car-search-icon" type="submit">
                          Search Properties
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Search Filter Section -->
</template>
<script>
  export default {
	data() {
		return {
			
			CategoryNine: ["Guest", "User", "Admin","Seller","Buyer"],
			
		}
	},
}
</script>
